import { CircularProgress } from '@forgeglobal/design-framework';
import cs from 'classnames';
import { useStyles } from './style';

interface SpinnerProps {
  className?: string;
  size?: 'normal' | 'small';
}

const SIZES = {
  small: 32,
  normal: 48,
};

const Spinner = ({ className, size = 'normal' }: SpinnerProps) => {
  const classes = useStyles();

  return (
    <div className={cs(classes.wrapper, className)}>
      <CircularProgress size={SIZES[size]} />
    </div>
  );
};

export default Spinner;
